import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const Delete1on1PlanClassRoomSilentlyMutation = gql`
  mutation delete1on1PlanClassRoomSilently($classRoomId: String!) {
    delete1on1PlanClassRoomSilently(classRoomId: $classRoomId)
  }
`;

export function useDelete1on1PlanClassRoomSilently() {
  const [mutate, { loading }] = useMutation(
    Delete1on1PlanClassRoomSilentlyMutation,
  );

  const deleteClassRoom = useCallback(
    async (classRoomId: string) => {
      await mutate({ variables: { classRoomId } });
    },
    [mutate],
  );

  return { deleteClassRoom, loading };
}
